import WorkerHashrates from './WorkerHashrates';

export default WorkerHashrates;
